import type { ConceptDef } from '../types';

export const eyeContactTimer: ConceptDef = {
  kind: 'timerHold',
  id: 'eye-contact-timer',
  label: 'Eye Contact Timer',
  category: 'Social',
  description: 'Hold a "look at me" prompt for a few seconds. Counts down.',
  config: {
    promptText: 'Look at me',
    holdSeconds: 3,
    rounds: 5,
  },
};
